import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { Common } from 'ws-scripts/modules/common';
import {
	VEHICLE_INCENTIVE,
	MANUFACTURER_OFFER,
	DEALER_OFFER,
	DISCLAIMER,
	OFFER_VALID,
	THROUGH
} from '../constants/constants';
import { closeSpecialsDetailsEvent } from '../utils/analytics';

class IncentiveModal extends React.Component {
	constructor(props) {
		super(props);
		this.close = this.close.bind(this);
	}

	close() {
		const { widgetName, windowId } = this.props;
		closeSpecialsDetailsEvent(widgetName, windowId);
		this.props.setModalStateData({}, false);
	}

	render() {
		const {
			disclaimer,
			conditional,
			title,
			offerDetails,
			effectiveDate,
			expirationDate
		} = this.props.incentive;

		const dialogTitle = (
			<Common
				render={({ labels }) => {
					return (
						<span className="h3 font-weight-bold">
							{labels.get(VEHICLE_INCENTIVE)}
						</span>
					);
				}}
			/>
		);

		let offer = MANUFACTURER_OFFER;
		if (conditional) {
			offer = DEALER_OFFER;
		}

		const dialogBody = (
			<Common
				render={({ labels }) => {
					let incentiveDisclaimer = '';
					if (disclaimer) {
						incentiveDisclaimer = (
							<div className="text-muted mt-4">
								<h4>{labels.get(DISCLAIMER)}</h4>
								<p>{disclaimer}</p>
							</div>
						);
					}

					return (
						<div>
							<h4 className="text-muted mt-2 mb-0">
								{labels.getHTML(offer)}
							</h4>
							<h2 className="mt-0">{title}</h2>
							<p>
								<span className="d-block">{offerDetails}</span>
								<span className="d-block">
									{labels.get(OFFER_VALID)} {effectiveDate}{' '}
									{labels.get(THROUGH)} {expirationDate}
								</span>
							</p>
							{incentiveDisclaimer}
						</div>
					);
				}}
			/>
		);

		return (
			<Modal show={this.props.isModalVisible} onHide={this.close}>
				<div className="m-1">
					<Modal.Header closeButton>
						<Modal.Title className="text-center">
							{dialogTitle}
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>{dialogBody}</Modal.Body>
				</div>
			</Modal>
		);
	}
}

IncentiveModal.propTypes = {
	incentive: PropTypes.shape({
		key: PropTypes.string,
		title: PropTypes.string,
		label: PropTypes.string,
		offerDetails: PropTypes.string,
		shortTitle: PropTypes.string,
		disclaimer: PropTypes.string,
		effectiveDate: PropTypes.string,
		expirationDate: PropTypes.string,
		conditional: PropTypes.bool,
		error: PropTypes.string
	}).isRequired,
	isModalVisible: PropTypes.bool.isRequired,
	setModalStateData: PropTypes.func.isRequired,
	windowId: PropTypes.string.isRequired,
	widgetName: PropTypes.string.isRequired
};

export default IncentiveModal;



// WEBPACK FOOTER //
// ./src/components/IncentiveModal.jsx